import type { AssumptionView } from "@shared/types";
import { ATLAS_WARNING } from "@shared/copy";
import { StatusPill } from "./Status";

export function AssumptionCard({ a, compact }: { a: AssumptionView; compact?: boolean }) {
  return (
    <article className="card" id={a.id}>
      <p className="kicker">{a.paramType}</p>
      <h3>{a.name}</h3>
      <div className="record-meta">
        <span>Adopted: {a.value} {a.units ?? ""}</span>
        {a.plausibleRange && <span>Range: {a.plausibleRange}</span>}
        <StatusPill status={a.epistemic} />
        <StatusPill status={a.verificationStatus} />
      </div>
      {!compact && (
        <>
          {a.rationale && <p>{a.rationale}</p>}
          <p className="muted small">
            Basis: {a.evidenceBasis ?? "not documented"} · Calibration support: {a.confidence ?? "not documented"} · Sensitivity: {a.sensitivity ?? "not documented"}
          </p>
          <p className="muted small">Scope: {a.spatialScope ?? "not documented"} · Model: {a.modelName}</p>
          {a.citations.map((c) => (
            <p key={c.id} className="cite">
              Source: {c.title}
              {c.page ? `, ${c.page}` : ""}
              {c.passage ? ` — “${c.passage}”` : ""}
              {c.url ? (
                <>
                  {" "}
                  <a href={c.url} rel="noreferrer">
                    original
                  </a>
                </>
              ) : null}
            </p>
          ))}
          {a.synthetic && <p className="muted small">{ATLAS_WARNING} This row is DEMO / SYNTHETIC.</p>}
        </>
      )}
    </article>
  );
}
